export const incomeSelector = state => state.reports.incomes.incomeTotal;
export const expensesSelector = state => state.reports.expenses.expenseTotal;

export const incomeDataSelector = state => state.reports.incomes.incomesData;
export const expensesDataSelector = state => state.reports.expenses.expensesData;

// export const CurrentCategoryAndId = 
